import * as React from "react";

import "./loading-message.scss";

export const loadingMessage = ({message,progress=50}) => (
    <div className="loading-message-hg4">
        <div className="message" xd-qa-type="label" xd-qa-name="Loading">
            {message}
        </div>
        <div className="icon">
            <progress id="file" value={progress} max="100"></progress>
        </div>
    </div>
);